import React, { useEffect } from 'react';
import Request from 'common/network/Request';
import { login, logout } from 'store/reducers/auth/slice';
import { useDispatch } from 'react-redux';
import { Divider, message, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';
import userApi from 'modules/auth/api';
import routes from 'routes/constants/routes';
import { authTokenKey } from 'constants/localStorage';

const Container = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    const fetchUserInfo = async () => {
      setLoading(true);
      const token = localStorage.getItem(authTokenKey);
      if (token) {
        try {
          const userInfo = await Request.get(userApi.userInfo); // Replace with your endpoint

          const info = userInfo?.result?.info;
          if (_.isEmpty(info)) {
            message.error('Đã xảy ra lỗi. Vui lòng đăng nhập lại.');
            dispatch(logout());
            navigate(routes.login);
          } else {
            dispatch(
              login({
                info,
                token,
              }),
            );
          }
        } catch (error) {
          message.error('Đã xảy ra lỗi. Vui lòng đăng nhập lại.');
          dispatch(logout());
          navigate(routes.login);
        }
      } else {
        navigate(routes.login);
      }
      setLoading(false);
    };

    fetchUserInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Spin
      spinning={loading}
      wrapperClassName="w-screen h-screen"
      className="h-full"
      rootClassName="h-full"
    >
      <div className="flex flex-col h-full">
        <div className="w-full text-center py-3 flex flex-col md:flex-row justify-center items-center shadow">
          <img
            src="/assets/images/logo.png"
            alt="Logo Bảo Việt Nhân Thọ"
            className="w-44 md:w-52 md:mx-3"
          />
          <Divider
            type="vertical"
            className="h-16 hidden md:block border-s-4"
          />
          <p className="md:mt-0 mt-4 text-pretty text-xl font-semibold tracking-tight md:text-3xl md:mx-3 text-primary uppercase">
            Sổ tay UVTN online
          </p>
        </div>
        <div className="flex-1">{loading ? null : children}</div>
      </div>
    </Spin>
  );
};

export default Container;
